import { Component, OnInit, AfterViewInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Global } from '../../../app.global';
import { SettingsService } from '../../../authentication/services/settings.service';
import { Constants } from '../../../shared/common/helper/constants';
import { PcnBlockComponent } from '../../../shared/common/components/pcn-block/pcn-block.component'; // ✅ Make sure this import path is correct

@Component({
  selector: 'app-welcome-layout',
  templateUrl: './welcome-layout.component.html',
  styleUrls: ['./welcome-layout.component.scss'],
})
export class WelcomeLayoutComponent implements OnInit, AfterViewInit {
  @ViewChild(PcnBlockComponent)
  pcnBlockComponent: PcnBlockComponent;

  public constants = Constants;
  isPcnPanelVisible = false;
  councilLogo = '';
  // Matches the spinner used elsewhere (documents-questions, letter components): a configurable
  // style driven by the Council.SpinnerStyle app setting, rather than this page's own bespoke
  // 'dot-flashing' spinner.
  loadingMessage = 'loading pcn details';
  spinnerStyle = 'spinner3';

  constructor(
    public global: Global,
    private settingsService: SettingsService,
    private route: ActivatedRoute
  ) {
    this.tokenCheck();
  }

  ngOnInit() {
    this.global.isPcnPinVisible = false;

    this.settingsService.getApplicationSetting('Council.Logo').subscribe(
      (result) => {
        this.councilLogo = result;
      },
      (_err) => {
        this.councilLogo = `${this.constants.assetsPath}/img/barbour-logic-logo.png`;
      }
    );

    this.settingsService.getApplicationSetting('Council.SpinnerStyle').subscribe(
      (result) => {
        this.spinnerStyle = typeof result === 'string' && result ? result : 'spinner3';
      },
      (_err) => {
        this.spinnerStyle = 'spinner3';
      }
    );
  }

  ngAfterViewInit(): void {
    this.injectPayloadIfPresent();
  }

  tokenCheck() {
    if (this.global.isTokenValid && !this.global.pcnNotComplete) {
      this.global.pcnPrepopulateLoading = true;
    }
  }

  injectPayloadIfPresent(): void {
    this.route.fragment.subscribe((frag) => {
      if (!frag) {
        return;
      }

      const encoded = frag.startsWith('p=') ? frag.slice(2) : frag;
      try {
        const obj = this.decodeBase64UrlJson(encoded);
        // loadFromPayload() owns global.pcnPrepopulateLoading's full lifecycle for this operation
        // (it sets it true itself, after its own resetPcn() call, and resets it on every exit path
        // it has) - it must not also be set here, since depending on the order relative to
        // loadFromPayload() this would either have no effect or stomp back over whatever
        // loadFromPayload() had just legitimately decided.
        this.pcnBlockComponent?.loadFromPayload(obj);
        this.clearOldNexusState();

        history.replaceState(null, '', location.pathname + location.search);
      } catch (e) {
        console.error('[PCN] Failed to decode fragment payload:', e);
      }
    });
  }

  decodeBase64UrlJson(s: string): any {
    try {
      s = decodeURIComponent(s);
    } catch {}
    s = s.replace(/-/g, '+').replace(/_/g, '/');
    const pad = s.length % 4;
    if (pad) {
      s += '='.repeat(4 - pad);
    }
    const json = atob(s);
    return JSON.parse(json);
  }

  clearOldNexusState(): void {
    Object.keys(localStorage)
      .filter(
        (key) => key.startsWith('nexus_') || key === 'payloadPdfUrl' || key === 'evidenceDocuments'
      )
      .forEach((key) => localStorage.removeItem(key));

    delete (window as any).__RM_EXTENSION_UPLOAD__;
  }
}
